import {moment} from 'helpers';
import {format} from '../decode/convert';

export function goals(goal) {
  let type = 'short';
  let isMajor = goal.parent_id ? 0 : 1;
  if (goal.isWeeklyObjective) {
    type = 'weekly_objective';
    isMajor = false;
  } else if (goal.category && !goal.parent_id) {
    type = goal.category;
  }
  return {
    achieveDate: goal.target_date ? moment.unix(goal.target_date).format(format) : '',
    dodifferently: goal.dodifferently,
    gain: goal.gain,
    goalTypeId: goal.typeId || null,
    goalTypeLocalId: goal.clarity ? 'clarity' : null,
    holdingback: goal.holdingback,
    importance: goal.importance,
    isMajor: isMajor,
    isSmart: goal.isSmart,
    localMark: goal.localMark,
    name: goal.name,
    note: goal.note,
    obstacle1: goal.obstacles,
    parentId: goal.parent_id || 0,
    price1: goal.price,
    quantitativeTarget: goal.target_value,
    risk1: goal.risks,
    serverId: goal.id,
    startingDate: goal.starting_date ? moment.unix(goal.starting_date).format(format) : '',
    startingPoint: goal.starting_value,
    status: goal.status == 'In Progress' ? null : goal.status,
    targetType: goal.progressType || 'cumulative',
    type,
    unit: goal.unit,
    unitId: goal.unitId,
  }
}
